module.exports = __webpack_public_path__ + "img/20191107162050381.24cbcf6d.jpg";